import { CompanyName, FULL_BUSINESS_URL, LocationCity } from '../Constants';

// Contact page
export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: 'Ascari Building Contractors',
    url: 'https://www.ascari-building-contractors.co.uk',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+44 7541476148',
      contactType: 'Customer Service',
      areaServed: 'GB',
      availableLanguage: ['English'],
    },
    sameAs: [
      'https://www.facebook.com/ascari-building-contractors',
      'https://www.instagram.com/ascari_building',
      'https://www.linkedin.com/company/ascari-building-contractors',
    ],
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.ascari-building-contractors.co.uk/brand/logo.png',
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: 'Contact Ascari Building Contractors' },
  {
    property: 'og:description',
    content:
      'Get in touch with Ascari Building Contractors for expert construction, carpentry, and renovation services across Devon & Cornwall.',
  },
  {
    property: 'og:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/contact-preview.jpg',
  },
  {
    property: 'og:url',
    content: 'https://www.ascari-building-contractors.co.uk/contact',
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Contact Ascari Building Contractors' },
  {
    name: 'twitter:description',
    content:
      'Reach out to Ascari Building Contractors for professional building and renovation services. Let’s discuss your project today!',
  },
  {
    name: 'twitter:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/contact-preview.jpg',
  },
];

export const carpentryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Carpentry',
  provider: {
    '@type': 'Organization',
    name: 'Ascari Building Contractors',
    url: 'https://www.ascari-building-contractors.co.uk',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.ascari-building-contractors.co.uk/brand/logo.png',
    },
  },
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 50.5495,
      longitude: -4.1443,
    },
    geoRadius: '50',
  },
  availableLanguage: ['English'],
};

export const carpentryPageAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Carpentry Services - Ascari Building Contractors',
  },
  {
    property: 'og:description',
    content:
      'Expert carpentry services from Ascari Building Contractors. High-quality joinery, bespoke woodwork, and precision craftsmanship in Devon & Cornwall.',
  },
  {
    property: 'og:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/carpentry-preview.jpg',
  },
  {
    property: 'og:url',
    content: 'https://www.ascari-building-contractors.co.uk/carpentry',
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Carpentry Services - Ascari Building Contractors',
  },
  {
    name: 'twitter:description',
    content:
      'Custom carpentry and woodwork by Ascari Building Contractors. Contact us today for expert craftsmanship in Devon & Cornwall!',
  },
  {
    name: 'twitter:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/carpentry-preview.jpg',
  },
];

export const bathroomsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Bathroom Renovation',
  provider: {
    '@type': 'Organization',
    name: 'Ascari Building Contractors',
    url: 'https://www.ascari-building-contractors.co.uk',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.ascari-building-contractors.co.uk/brand/logo.png',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Tavistock',
      addressRegion: 'Devon',
      addressCountry: 'UK',
    },
  },
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 50.5495,
      longitude: -4.1443,
    },
    geoRadius: '50',
  },
  availableLanguage: ['English'],
};

export const bathroomsPageAdditionalMeta = [
  {
    property: 'og:title',
    content: 'Bathroom Renovation Services - Ascari Building Contractors',
  },
  {
    property: 'og:description',
    content: `Transform your bathroom with expert renovation and installation services from Ascari Building Contractors in ${LocationCity}.`,
  },
  {
    property: 'og:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/bathroom-preview.jpg',
  },
  {
    property: 'og:url',
    content: 'https://www.ascari-building-contractors.co.uk/bathrooms',
  },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: 'Bathroom Renovation Services - Ascari Building Contractors',
  },
  {
    name: 'twitter:description',
    content: `Looking for bathroom renovations in ${LocationCity}? Contact Ascari Building Contractors for expert remodeling services.`,
  },
  {
    name: 'twitter:image',
    content:
      'https://www.ascari-building-contractors.co.uk/brand/bathroom-preview.jpg',
  },
];

export const groundworksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Groundworks',
  provider: {
    '@type': 'Organization',
    name: 'Ascari Building Contractors',
    url: 'https://www.ascari-building-contractors.co.uk',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.ascari-building-contractors.co.uk/brand/logo.png',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: LocationCity,
      addressRegion: 'Devon',
      addressCountry: 'UK',
    },
  },
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 50.5495,
      longitude: -4.1443,
    },
    geoRadius: '50',
  },
  availableLanguage: ['English'],
};

export const groundworksPageAdditionalMeta = [
  { property: 'og:title', content: 'Groundworks Services - Ascari Building Contractors' },
  {
    property: 'og:description',
    content: `Get expert groundworks services from Ascari Building Contractors in ${LocationCity}. We handle everything from excavation to drainage.`,
  },
  {
    property: 'og:image',
    content: 'https://www.ascari-building-contractors.co.uk/brand/groundworks-preview.jpg',
  },
  { property: 'og:url', content: 'https://www.ascari-building-contractors.co.uk/groundworks' },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Groundworks Services - Ascari Building Contractors' },
  {
    name: 'twitter:description',
    content: `Looking for professional groundworks in ${LocationCity}? Contact Ascari Building Contractors for reliable site preparation and excavation services.`,
  },
  {
    name: 'twitter:image',
    content: 'https://www.ascari-building-contractors.co.uk/brand/groundworks-preview.jpg',
  },
];

export const buildingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Building Services',
  provider: {
    '@type': 'Organization',
    name: 'Ascari Building Contractors',
    url: 'https://www.ascari-building-contractors.co.uk',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.ascari-building-contractors.co.uk/brand/logo.png',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: LocationCity,
      addressRegion: 'Devon',
      addressCountry: 'UK',
    },
  },
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 50.5495,
      longitude: -4.1443,
    },
    geoRadius: '50',
  },
  availableLanguage: ['English'],
};

export const buildingPageAdditionalMeta = [
  { property: 'og:title', content: 'Building Services - Ascari Building Contractors' },
  {
    property: 'og:description',
    content: `Looking for professional building services in ${LocationCity}? Ascari Building Contractors offer new builds, renovations, and more.`,
  },
  {
    property: 'og:image',
    content: 'https://www.ascari-building-contractors.co.uk/brand/building-preview.jpg',
  },
  { property: 'og:url', content: 'https://www.ascari-building-contractors.co.uk/building' },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Building Services - Ascari Building Contractors' },
  {
    name: 'twitter:description',
    content: `Ascari Building Contractors specializes in building services in ${LocationCity}. Whether it's a new build or renovation, we’re here to help.`,
  },
  {
    name: 'twitter:image',
    content: 'https://www.ascari-building-contractors.co.uk/brand/building-preview.jpg',
  },
];

// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];
